import { ChangeDetectorRef, Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { NgxSpinnerService } from "ngx-spinner";
import { AppService } from "src/app/services/app/app.service";
import { UserManagementService } from "src/app/services/user_management/user-management.service";
import { EditUserComponent } from "../dialog-modal/edit-user/edit-user.component";
import { CompanyService } from "src/app/services/company/company.service";
import { DatePipe } from "@angular/common";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { minDateValidator } from "src/app/custom-validators/min-date";
import { CommonService } from "src/app/services/common/common.service";
import { startDateBeforeEndDateValidator } from "src/app/model/start_end_date";

@Component({
  selector: "app-add-important-notice",
  templateUrl: "./add-important-notice.component.html",
  styleUrls: ["./add-important-notice.component.scss"],
})
export class AddImportantNoticeComponent {
  public noticeForm!: FormGroup;
  public minDate = new Date()
  public departmentData:any[]=[]
  dropdownSettings: IDropdownSettings = {};
  public isSpinnerLoading:boolean=false;
  public showDepError :boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    public userManagementService:UserManagementService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private cd: ChangeDetectorRef,
    private appService: AppService,
    public dialogRef: MatDialogRef<AddImportantNoticeComponent>,
    private companyService:CompanyService,
    private datePipe: DatePipe,
    private commonService :CommonService
  ) {}
  ngOnInit(): void {

    this.noticeForm = this.fb.group({
      tit: [ "", Validators.compose([  Validators.required, Validators.minLength(1),Validators.maxLength(100), ])],
      desc: ["", Validators.compose([Validators.required, Validators.minLength(3)]),],
      d_i: [0, Validators.required],
      st_dt: ["", Validators.compose([Validators.required,])],
      ed_dt: ["", Validators.required],
    },
    {validator: startDateBeforeEndDateValidator('st_dt','ed_dt')}
    // Validators.bind(minDateValidator(this.noticeForm,'st_dt' ))
    );
    this.departmentList()
    this.dropdownSettings = {
      idField: 'cd_i',
      textField: 'dep',
      // below setting will help to enable search filter in multi select dropdown
    };
  }
  onSchemesChanged(tag:boolean){
    if( this.noticeForm.value.d_i == 0 && tag ){
      this.showDepError = tag;
    }else{
      this.showDepError = false;
    }
  }
  departmentList(){
    this.spinner.show();
    let obj={}
    this.userManagementService.departmentListing(obj).subscribe({next:(success: any) => {

      this.spinner.hide();
      if (success.status == 200) {
        this.departmentData = success.data;
        // this.initManager();
        // this.cd.markForCheck();
      }
    },
  
    error: (error: any) => {
      this.commonService.handleError(error)
    }});
  }
  checkDates(group: FormGroup) {
    if(group.controls['ed_dt'].value < group.controls['st_dt'].value) {
    return { startDtBeforeEndDt:true }
    }
    return null;
 }
  isControlHasError(controlName: string, validationType: string): boolean {
    return this.appService.isControlHasError( this.noticeForm,controlName, validationType);
  }
  onCancel() {this.dialogRef.close()}
  onSubmit() {

    // return
    if (this.noticeForm.invalid || this.noticeForm.value.d_i == 0) {
      this.noticeForm.markAllAsTouched()
      this.showDepError = true;
      return;
  }
  if (!this.noticeForm.invalid) {
      let newDepId:any[]=[];
      for(let i=0;i<this.noticeForm.value.d_i.length;i++){
        newDepId.push(this.noticeForm.value.d_i[i].cd_i)
      }
      let data: any = {
        tit: this.noticeForm.value.tit,
        desc: this.noticeForm.value.desc,
        st_dt: this.datePipe.transform(this.noticeForm.get("st_dt")?.value, 'yyyy-MM-dd'),
        ed_dt: this.datePipe.transform(this.noticeForm.get("ed_dt")?.value, 'yyyy-MM-dd') ,
        d_i: newDepId
    }
    if(this.departmentData.length==newDepId.length){
        data["d_i"]=[]
    }
       this.spinner.show();
      this.companyService.addNotice(data).subscribe({
        next: (success: Object) => {
          this.spinner.hide();
          // this.myApp.successToast(success.msg);
          if (success["status"] == 200) {
            this.appService.showToastMessage("success", success["msg"]);
            this.dialogRef.close({ data_added: true });
            // this.reset();
            // this.router.navigateByUrl('important-notice');
          }
        },
        error: (error: any) => {
          this.spinner.hide();
          this.commonService.handleError(error);
        },
      });
  }
  }
}
